module.exports = __webpack_public_path__ + "static/img/101845.4d8761fe.png";